module.exports = __webpack_public_path__ + "static/media/Artboard2.676aa95b.png";